"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ = require("../..");
var _DndProvider = _interopRequireDefault(require("../DndProvider/DndProvider"));
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _useLazyLoading2 = require("../../hooks/useLazyLoading");
var _LazyLoader = require("../../constants/LazyLoader");
var _elementErrorBoundaryPropsHelper = require("../../utils/elementErrorBoundaryPropsHelper");
var _ComponentTypes = require("../../constants/ComponentTypes");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _SourceListItem = _interopRequireDefault(require("./SourceListItem"));
var _SourceList = require("./SourceList.styled");
var _MediaPlayerSettingsPropType = _interopRequireDefault(require("../MediaPlayerSettingsPropType"));
var _SourceListDnd = _interopRequireDefault(require("./SourceListDnd"));
var _constants = require("@studio/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SourceList = function SourceList(_ref) {
  var enableFeature = _ref.enableFeature,
    isDraggingSource = _ref.isDraggingSource,
    tab = _ref.tab,
    sources = _ref.sources,
    onSourceSetToLive = _ref.onSourceSetToLive,
    onSourceEdited = _ref.onSourceEdited,
    onSourceDeleted = _ref.onSourceDeleted,
    onFeaturedToggleClicked = _ref.onFeaturedToggleClicked,
    onMuteToggleClicked = _ref.onMuteToggleClicked,
    onLiveToggleClicked = _ref.onLiveToggleClicked,
    onLoopToggleClicked = _ref.onLoopToggleClicked,
    liveSources = _ref.liveSources,
    onSourceHidden = _ref.onSourceHidden,
    mediaPlayerSettings = _ref.mediaPlayerSettings,
    onVolumeChanged = _ref.onVolumeChanged,
    isMaxUnhiddenCamerasOn = _ref.isMaxUnhiddenCamerasOn,
    attendeeCameraStatus = _ref.attendeeCameraStatus,
    onCameraToggleClicked = _ref.onCameraToggleClicked,
    isMaximumCameraSourcesOn = _ref.isMaximumCameraSourcesOn,
    stagedSources = _ref.stagedSources,
    onSourceStaged = _ref.onSourceStaged,
    isStagedSourcesActive = _ref.isStagedSourcesActive,
    onReorderSources = _ref.onReorderSources,
    onDragSource = _ref.onDragSource,
    onThumbnailReady = _ref.onThumbnailReady,
    onUploadClicked = _ref.onUploadClicked,
    onSetSourceUnassigned = _ref.onSetSourceUnassigned,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    params = _ref.params,
    attendeeId = _ref.attendeeId,
    onAssignSpeakers = _ref.onAssignSpeakers,
    onReplaceSlides = _ref.onReplaceSlides,
    onPdfAssignClicked = _ref.onPdfAssignClicked,
    onPresentationLoadSuccess = _ref.onPresentationLoadSuccess,
    onGoToPresentationPage = _ref.onGoToPresentationPage,
    layout = _ref.layout,
    _ref$AttendeeTileComp = _ref.AttendeeTileComponent,
    AttendeeTileComponent = _ref$AttendeeTileComp === void 0 ? _.AttendeeTile : _ref$AttendeeTileComp;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var sourceListRef = (0, _react.useRef)(null);
  var _useLazyLoading = (0, _useLazyLoading2.useLazyLoading)(_LazyLoader.SOURCES_ID_PREFIX),
    visibleItemsMap = _useLazyLoading.visibleItemsMap,
    registerLazyLoadedContainer = _useLazyLoading.registerLazyLoadedContainer,
    updateItems = _useLazyLoading.updateItems;
  var emptyText = 'No sources available';
  var errorBoundaryProps = (0, _elementErrorBoundaryPropsHelper.getElementErrorBoundaryProps)(_ComponentTypes.SOURCE);
  (0, _react.useEffect)(function () {
    if (sourceListRef.current) {
      registerLazyLoadedContainer(sourceListRef);
    }
  }, [sourceListRef, registerLazyLoadedContainer]);
  (0, _react.useEffect)(function () {
    updateItems(sources);
  }, [sources, updateItems]);
  var checkCameraIsOn = (0, _react.useCallback)(function (sourceValue) {
    var _attendeeCameraStatus;
    return (_attendeeCameraStatus = attendeeCameraStatus[sourceValue]) !== null && _attendeeCameraStatus !== void 0 ? _attendeeCameraStatus : false;
  }, [attendeeCameraStatus]);
  var hasSources = (0, _react.useMemo)(function () {
    return !!(sources !== null && sources !== void 0 && sources.length);
  }, [sources]);
  var handleLiveClicked = (0, _react.useCallback)(function (source) {
    return onSourceSetToLive(source);
  }, [onSourceSetToLive]);
  var handleSourceEdited = (0, _react.useCallback)(function (source) {
    return onSourceEdited(source);
  }, [onSourceEdited]);
  var handleSourceDeleted = (0, _react.useCallback)(function (source) {
    return onSourceDeleted(source);
  }, [onSourceDeleted]);
  var handleSourceHidden = (0, _react.useCallback)(function (source) {
    return onSourceHidden(source);
  }, [onSourceHidden]);
  var handleFeaturedToggleClicked = (0, _react.useCallback)(function (source) {
    return onFeaturedToggleClicked(source);
  }, [onFeaturedToggleClicked]);
  var handleMuteToggleClicked = (0, _react.useCallback)(function (source) {
    return onMuteToggleClicked(source);
  }, [onMuteToggleClicked]);
  var handleLiveToggleClicked = (0, _react.useCallback)(function (source) {
    return onLiveToggleClicked(source);
  }, [onLiveToggleClicked]);
  var handleLoopToggleClicked = (0, _react.useCallback)(function (source) {
    return onLoopToggleClicked(source);
  }, [onLoopToggleClicked]);
  var handleVolumeChanged = (0, _react.useCallback)(function (source, value) {
    return onVolumeChanged(source, value);
  }, [onVolumeChanged]);
  var handleCameraToggleClicked = (0, _react.useCallback)(function (source) {
    return onCameraToggleClicked(source);
  }, [onCameraToggleClicked]);
  var handleSourceStaged = (0, _react.useCallback)(function (source) {
    return onSourceStaged(source);
  }, [onSourceStaged]);
  var handleThumbnailReady = (0, _react.useCallback)(function (source, thumbnail) {
    return onThumbnailReady(source, thumbnail);
  }, [onThumbnailReady]);
  var handleUploadClicked = (0, _react.useCallback)(function (source) {
    return onUploadClicked(source);
  }, [onUploadClicked]);
  var handleSetSourceUnassigned = (0, _react.useCallback)(function (source) {
    return onSetSourceUnassigned(source);
  }, [onSetSourceUnassigned]);
  var handleAssignSpeakers = (0, _react.useCallback)(function (source) {
    return onAssignSpeakers(source);
  }, [onAssignSpeakers]);
  var handleReplaceSlides = (0, _react.useCallback)(function (source) {
    return onReplaceSlides(source);
  }, [onReplaceSlides]);
  var handlePdfAssignClicked = (0, _react.useCallback)(function (source) {
    return onPdfAssignClicked(source);
  }, [onPdfAssignClicked]);
  var handlePresentationLoadSuccess = (0, _react.useCallback)(function (source, pdf) {
    return onPresentationLoadSuccess(source, pdf);
  }, [onPresentationLoadSuccess]);
  var handleGoToPresentationPage = (0, _react.useCallback)(function (source, page) {
    return onGoToPresentationPage(source, page);
  }, [onGoToPresentationPage]);
  var displayListComponent = (0, _react.useCallback)(function (errorBoundaryProps) {
    var sourceMap = new Map();
    sources.forEach(function (s, idx) {
      if (!isStudioLite || s.value !== _constants.UNASSIGNED) {
        sourceMap.set( /*#__PURE__*/_react["default"].createElement(_.ElementErrorBoundary, (0, _extends2["default"])({
          key: s._id
        }, errorBoundaryProps), /*#__PURE__*/_react["default"].createElement(_SourceListItem["default"], {
          index: idx,
          enableFeature: enableFeature,
          dragAndDrop: true,
          live: liveSources.includes(s._id),
          loop: (0, _typeof2["default"])(s.value) === 'object' && s.value.loop,
          volume: (mediaPlayerSettings[s._id] || {}).volume,
          onLiveClicked: handleLiveClicked,
          onSourceEdited: handleSourceEdited,
          onSourceDeleted: handleSourceDeleted,
          onSourceHidden: handleSourceHidden,
          onFeaturedToggleClicked: handleFeaturedToggleClicked,
          onMuteToggleClicked: handleMuteToggleClicked,
          onLiveToggleClicked: handleLiveToggleClicked,
          onLoopToggleClicked: handleLoopToggleClicked,
          onVolumeChanged: handleVolumeChanged,
          key: "sourceListItem-".concat(s._id),
          source: s,
          isMaxUnhiddenCamerasOn: !isMaxUnhiddenCamerasOn ? false : isMaxUnhiddenCamerasOn(s),
          onCameraToggleClicked: handleCameraToggleClicked,
          isCameraOn: checkCameraIsOn((0, _broadcastSourceHelper.getSourceValue)(s)),
          isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
          isStaged: stagedSources[s._id],
          onSourceStaged: handleSourceStaged,
          isStagedSourcesActive: isStagedSourcesActive,
          onReorderSources: onReorderSources,
          onDragSource: onDragSource,
          isDraggingSource: isDraggingSource,
          prevSource: idx > 0 ? sources[idx - 1] : {},
          onThumbnailReady: handleThumbnailReady,
          onUploadClicked: handleUploadClicked,
          onSetSourceUnassigned: handleSetSourceUnassigned,
          user: user,
          viewPermissions: viewPermissions,
          attendeeTiles: attendeeTiles,
          meetingSession: meetingSession,
          isDirectorSource: s.value === attendeeId,
          onAssignSpeakers: handleAssignSpeakers,
          onReplaceSlides: handleReplaceSlides,
          onPdfAssignClicked: handlePdfAssignClicked,
          onPresentationLoadSuccess: handlePresentationLoadSuccess,
          onGoToPresentationPage: handleGoToPresentationPage,
          layout: layout,
          AttendeeTileComponent: AttendeeTileComponent
        })));
      }
    });
    return sourceMap;
  }, [visibleItemsMap, sources, liveSources, mediaPlayerSettings, isMaximumCameraSourcesOn, stagedSources, isStagedSourcesActive, isDraggingSource, onSourceSetToLive, handleSourceEdited, handleSourceDeleted, handleSourceHidden, handleFeaturedToggleClicked, handleMuteToggleClicked, handleLiveToggleClicked, handleLoopToggleClicked, handleVolumeChanged, isMaxUnhiddenCamerasOn, handleCameraToggleClicked, handleSourceStaged, onReorderSources, onDragSource, handleThumbnailReady, handleUploadClicked, checkCameraIsOn, enableFeature, handleSetSourceUnassigned, AttendeeTileComponent, isStudioLite, attendeeId, user, viewPermissions, attendeeTiles, meetingSession, layout, errorBoundaryProps, handleLiveClicked]);
  return /*#__PURE__*/_react["default"].createElement(_contexts.ParamsContext.Provider, {
    value: params
  }, /*#__PURE__*/_react["default"].createElement(_DndProvider["default"], null, /*#__PURE__*/_react["default"].createElement(_SourceListDnd["default"], null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hasSources && /*#__PURE__*/_react["default"].createElement(_SourceList.StyledTextWrapper, null, /*#__PURE__*/_react["default"].createElement(_SourceList.StyledText, {
    isStudioLite: isStudioLite
  }, emptyText)), hasSources && displayListComponent(errorBoundaryProps)))));
};
SourceList.propTypes = {
  enableFeature: _propTypes.bool,
  tab: _propTypes.string,
  sources: _propTypes.array.isRequired,
  onSourceSetToLive: _propTypes.func.isRequired,
  onSourceEdited: _propTypes.func.isRequired,
  onSourceDeleted: _propTypes.func.isRequired,
  onFeaturedToggleClicked: _propTypes.func.isRequired,
  onMuteToggleClicked: _propTypes.func.isRequired,
  liveSources: _propTypes.array,
  onSourceHidden: _propTypes.func,
  onLiveToggleClicked: _propTypes.func.isRequired,
  onLoopToggleClicked: _propTypes.func.isRequired,
  mediaPlayerSettings: _MediaPlayerSettingsPropType["default"],
  onVolumeChanged: _propTypes.func.isRequired,
  attendeeMuteStatus: _propTypes.object,
  isMaxUnhiddenCamerasOn: _propTypes.func,
  onCameraToggleClicked: _propTypes.func.isRequired,
  attendeeCameraStatus: _propTypes.object,
  isMaximumCameraSourcesOn: _propTypes.bool,
  stagedSources: _propTypes.object,
  onSourceStaged: _propTypes.func.isRequired,
  isStagedSourcesActive: _propTypes.bool,
  onReorderSources: _propTypes.func.isRequired,
  onDragSource: _propTypes.func.isRequired,
  isDraggingSource: _propTypes.bool,
  onThumbnailReady: _propTypes.func,
  onUploadClicked: _propTypes.func,
  onSetSourceUnassigned: _propTypes.func,
  viewPermissions: _propTypes.object,
  user: _propTypes.object,
  attendeeTiles: _propTypes.object,
  meetingSession: _propTypes.object,
  params: _propTypes.object,
  attendeeId: _propTypes.string,
  onAssignSpeakers: _propTypes.func,
  onReplaceSlides: _propTypes.func,
  onPresentationLoadSuccess: _propTypes.func,
  onGoToPresentationPage: _propTypes.func,
  AttendeeTileComponent: _propTypes.elementType
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SourceList);